import { z } from 'zod';

import { isDefined } from '../../../utils.js';

export enum ExportExternalDocumentPacketReasons {
  FailedMedicalNecessity = 'FailedMedicalNecessity',
  OutOfScope = 'OutOfScope',
}

/** Mirrors `hasDirectoryTraversal` in notable-common, which the web workspace cannot resolve. */
export function hasDirectoryTraversal(filePath: string | undefined): boolean {
  return isDefined(filePath) && filePath.split(/[/\\]/).includes('..');
}

export const ExportExternalDocumentPacketBlockConfigSchema = z.object({
  externalDocumentPacket: z.object({
    sourceBlockName: z.string(),
  }),
  exportReason: z.enum(ExportExternalDocumentPacketReasons),
  filePath: z
    .string()
    .optional()
    .refine((filePath) => !hasDirectoryTraversal(filePath), {
      message: 'Directory traversal attempts (..) are not allowed in file paths',
    }),
});

export type ExportExternalDocumentPacketBlockConfig = z.infer<
  typeof ExportExternalDocumentPacketBlockConfigSchema
>;
